import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { ApplicationItem } from '../../../quotas/models/application.interface';
import { Quota } from '../../../quotas/models/quota.interface';
import { KgToTonsPipe } from '../../../../shared/pipes/kg-to-tons.pipe';
import { SupplierTypePipe } from '../../../../shared/pipes/supplier-type.pipe';
import { StatusLabelPipe } from '../../../../shared/pipes/status-label.pipe';
import { StatusClassPipe } from '../../../../shared/pipes/status-class.pipe';
import { VetDocStatusPipe } from '../../../../shared/pipes/vet-doc-status.pipe';
import { QuotaStatusPipe } from '../../../../shared/pipes/quota-status.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export interface QuotaDetailsDialogData {
  quota: Quota;
  applications: ApplicationItem[];
}

@Component({
  selector: 'app-quota-details-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    KgToTonsPipe,
    SupplierTypePipe,
    StatusLabelPipe,
    StatusClassPipe,
    VetDocStatusPipe,
    QuotaStatusPipe,
    TranslateModule
  ],
  templateUrl: './quota-details-dialog.html',
  styleUrl: './quota-details-dialog.css'
})
export class QuotaDetailsDialogComponent {
  displayedColumns = [
    'id',
    'applicationNumber',
    'companyName',
    'companyInn',
    'proxyDocumentNumber',
    'proxyDocumentDate',
    'vetServiceIssueDate',
    'vetServiceIssueNumber',
    'applicantFullName',
    'applicantPassportNumber',
    'applicantPhoneNumber',
    'applicantEmail',
    'meatType',
    'requestedVolume',
    'volumeForLastNineMonths',
    'volumeForLastTwelveMonths',
    'supplierType',
    'veterinaryDocumentStatus',
    'quotaStatus',
    'applicationStatus'
  ];

  private translate: TranslateService;

  constructor(
    public dialogRef: MatDialogRef<QuotaDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QuotaDetailsDialogData,
    translate: TranslateService
  ) {
    this.translate = translate;
  }

  close(): void {
    this.dialogRef.close();
  }

  getMeatTypeName(meatType: any): string {
    if (!meatType) return '';
    const lang = this.translate.currentLang || 'ru';
    return lang === 'ky' ? meatType.nameKy : meatType.nameRu;
  }
}
